import { AnalysisStatusEnum, AnalysisStatusLabelEnum } from 'submodules/nerit-aquatec-sdk/common/enums/AnalysisStatusEnum'

/**
 * Utilitarios de apresentacao do status de analise (Tela 3.3 - Controle de Parametros).
 * O status e sempre derivado e somente leitura.
 */
export class AnalysisStatusUtils {

    /**
     * Cor da TagCP para cada status de analise.
     */
    static getColor(status: AnalysisStatusEnum): string {
        switch (status) {
            case AnalysisStatusEnum.ANALYZED:
                return 'green'
            case AnalysisStatusEnum.WAITING_ANALYSIS:
                return 'orange'
            default:
                return 'blue'
        }
    }

    /**
     * Label em PT para o status.
     */
    static getLabel(status: AnalysisStatusEnum): string {
        return AnalysisStatusLabelEnum[status] ?? status
    }

}
